"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var _1 = require(".");

require("./list.less");

require("./form.less");

var List = function (_super) {
  __extends(List, _super);

  function List(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      value: props.value || [],
      isValid: !!props.value
    };
    return _this;
  }

  List.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
  };

  List.prototype.onValue = function (field, value, isValid) {
    var array = this.state.value.filter(function (item) {
      return item !== value;
    });

    switch (field) {
      case "input":
        array.push(value);
        break;

      case "remove":
        break;
    }

    var context = this.props.context;
    var fieldName = this.props.field;
    this.setState({
      value: array,
      isValid: true
    });
    context.onValue(fieldName, array, true);
  };

  List.prototype.onAction = function (action) {};

  List.prototype.render = function () {
    var _this = this;

    var label = "";

    if (this.props.label) {
      label = React.createElement("label", null, this.props.label);
    }

    return React.createElement("div", {
      className: "input list-input boxed-shadow"
    }, label, React.createElement(_1.Autocomplete, {
      field: "input",
      clearInput: true,
      options: this.props.options,
      placeholder: this.props.placeholder,
      context: this
    }), React.createElement("div", {
      className: "list-wrapper"
    }, this.state.value.map(function (item, key) {
      return React.createElement("span", {
        className: "list-item",
        key: key
      }, item, React.createElement("span", {
        className: "remove-item",
        onClick: function onClick() {
          return _this.onValue("remove", item, true);
        }
      }));
    })));
  };

  return List;
}(React.Component);

exports["default"] = List;